import { useEffect } from "react";
import { useForceRender } from "shared/hooks/useForceRender.hook";
import { useAppDispatch } from "shared/lib/redux";
import { changeLanguage } from "shared/localization/localization";

import { langStore } from "../../model/lang.store";

export const useLang = ({ lang }: { lang: string }) => {
  const dispatch = useAppDispatch();
  const { forceRender } = useForceRender();

  const handleChangeLanguage = () => {
    dispatch(langStore.actions.setLang(lang));
    changeLanguage(lang, () => forceRender());
  };

  useEffect(() => handleChangeLanguage(), [lang]);
};
